import { ListDefault } from './Attributes/ListDefault.js';

export const Attributes = (props) => {
    const { entity, datas } = props;
    if (datas && datas.length > 0) {
        switch (entity) {
            case 'author':
            case 'evacuation':
            case 'family':
            case 'handicap':
            case 'height':
            case 'interest':
            case 'origintype':
            case 'photopass':
            case 'pmr':
            case 'premieraccess':
            case 'public':
            case 'sensory':
            case 'serie':
            case 'singlerider':
            case 'sort': return (<ListDefault entity={entity} datas={datas} />);
            default: return (<></>);
        }
    } else {
        return (<></>);
    }

}